import React from "react";
import PropTypes from "prop-types";
import Slider from "./Slider";
import Loader from "../Loader/Loader.js";

import "./CardSlider.scss";

const CardSlider = ({
  items,
  loading,
  onTakeOn,
  onTakeOff,
  onSetHidden,
  onSetRatio,
  onSetPacket,
  canTakeOn,
  user,
  permissions
}) => {
  if (loading) {
    return (
      <div className="card-slider card-slider__empty">
        <Loader />
      </div>
    );
  }

  if (!loading && items.length == 0) {
    return (
      <div className="card-slider card-slider__empty">
        Нет кампаний по данному запросу
      </div>
    );
  }

  return (
    <div className="card-slider">
      <Slider
        items={items}
        onTakeOn={onTakeOn}
        onTakeOff={onTakeOff}
        canTakeOn={canTakeOn}
        user={user}
        onSetHidden={onSetHidden}
        onSetRatio={onSetRatio}
        onSetPacket={onSetPacket}
        permissions={permissions}
      />
    </div>
  );
};

CardSlider.propTypes = {
  items: PropTypes.array.isRequired,
  onTakeClick: PropTypes.func
};

export default CardSlider;
